import { organization } from './organization';

export const frCA = { organization };
